module.exports = __webpack_public_path__ + "img/ipad-mobile.0dbe6dd6.jpg";